module.exports = __webpack_public_path__ + "static/media/sarcastic.bc9d52c8.png";